var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{class:['image', _vm.data.className ? _vm.data.className : ''],attrs:{"data-tooltip":_vm.$t(_vm.data.tooltip)}},[_c('img',{attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }